import { Overrides } from '@material-ui/core/styles/overrides';
import { CORPORATE_COLORS } from '@Ui/theme/colors/corporate';

export const typographyOverrides: Overrides = {
  MuiTypography: {
    root: {
      color: CORPORATE_COLORS.TEXT_PRIMARY
    },
    h2: {
      fontSize: '20px',
      lineHeight: '30px',
      fontWeight: 500,
      fontFamily: ['"New Brand"', '"Helvetica Neue"', '"Nimbus Sans L"', 'sans-serif'].join(',')
    },
    h3: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 'bold',
      fontFamily: ['"New Brand"', '"Helvetica Neue"', '"Nimbus Sans L"', 'sans-serif'].join(',')
    },
    subtitle1: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 500,
      fontFamily: ['"New Brand"', '"Helvetica Neue"', '"Nimbus Sans L"', 'sans-serif'].join(',')
    },
    subtitle2: {
      fontSize: '14px',
      lineHeight: '21px',
      fontWeight: 'bold',
      fontFamily: ['"New Brand"', '"Helvetica Neue"', '"Nimbus Sans L"', 'sans-serif'].join(',')
    },
    body1: {
      fontSize: '14px',
      lineHeight: '21px',
      fontFamily: ['"New Brand"', '"Helvetica Neue"', '"Nimbus Sans L"', 'sans-serif'].join(','),
      '& a': {
        color: CORPORATE_COLORS.DARK_BLUE
      }
    },
    colorTextSecondary: {
      color: CORPORATE_COLORS.CONTENT_DARK_PRIMARY_LOW
    }
  }
};
